import { type FormEventHandler, forwardRef, useId } from "react";

import { NodeProperty } from "@/components/doc/right-sidebar/node-viewer/NodeProperty";
import { keyMatcher } from "@/utils/keyMatcher";
import { twMerge } from "@/utils/twMerge";

type Props = {
  label: string;
  onSubmit?: FormEventHandler<HTMLInputElement>;
  className?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const NodePropertyInput = forwardRef<HTMLInputElement, Props>(function NodePropertyInput(
  { value, label, className, onSubmit = () => {}, ...props }: Props,
  ref,
) {
  // Callers pass the same ids ("value", "name") for every object, so they can't be DOM ids
  const formId = useId();

  function handleOnKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (keyMatcher("Enter", e)) {
      onSubmit(e);
    }
  }

  return (
    <NodeProperty
      name={<label htmlFor={formId}>{label}</label>}
      hideToggle
      value={
        <input
          data-testid="node-property-input"
          type="text"
          className={twMerge("bg-transparent w-full outline-none", className)}
          onKeyDown={handleOnKeyDown}
          onBlur={onSubmit}
          value={value}
          ref={ref}
          {...props}
          id={formId}
          data-1p-ignore
        />
      }
    />
  );
});
